import api from ".";
import cookiesModifier from "../utils/cookies";

export const updateSection = async (data: any) => {
    const url = `sections/${data.id}`;

    try {
        const res = await api.patch(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const createSection = async (payload: { title: string, help: string, questionnaireId: number | undefined, criteriaGroupId: number | undefined }) => {
    const url = `sections`;

    try {
        const res = await api.post(url, payload);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const reorderSection = async (payload: { id: number, action: string }) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`sections/reorder/${payload.id}/${payload.action}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteSection = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`sections/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}